<template>
    <mm-select :options="options" v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
const options = [
	
	{
		value:'processing',
		label:'Processing',
		class:'status-processing'
	},
	{
		value:'confirm',
		label:'Confirm',
		class:'status-confirm'
	},
]

export default{
	data(){
		return {
			options,
		}
	},
	props:['value']
}
</script>